import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnyoComponent } from 'projects/app-core/src/app/models/AnyoComponent';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { MasterdataService } from '../../../services/masterdata.service';
import { PackService } from '../../../services/packs.service';
import { AnyoPackSubscriptionGridRequest } from '../../../models/packs/AdminPacksSubscriptionGridRequest';
import {
  AnyoPacksSubscriptionResponse,
  PacksUserDetails,
} from '../../../models/packs/AnyoPacksSubscriptionGridResponse';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { TherapyPaymentType } from '../../../models/TherapyPlans';
import { FileUtilsService } from 'projects/app-core/src/service/fileService';
import { lastValueFrom } from 'rxjs';
import * as moment from 'moment';
interface CheckboxOptions {
  label: string;
  value: string;
  checked: boolean;
}

interface AnyoPacksSubscriptionExportData {
  packName: string;
  activedOn: number;
  validTill: number;
  totalPacks: number;
  activePacks: number;
  completedPacks: number;
  totalPackValue: number;
  paymentType: TherapyPaymentType;
  primaryConcern: string;
  primaryTherapistDetails: string;
  auxiliaryTherapistDetails: string;
  numberOfPrimarySessions: number;
  numberOfAuxiliarySessions: number;
  userDetails: PacksUserDetails;
  completedPrimarySession: number;
  completedAuxiliarySession: number;
  auxiliaryConcern: string;
}
@Component({
  selector: 'app-anyo-packs-subcription',
  templateUrl: './anyo-packs-subcription.component.html',
  styleUrl: './anyo-packs-subcription.component.scss',
})
export class AnyoPacksSubscriptionComponent extends AnyoComponent {
  constructor(
    auth: AuthService,
    private toastService: ToastService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private masterdataService: MasterdataService,
    private packService: PackService,
    public utils: UtilsService,
    private fileUtil: FileUtilsService,
  ) {
    super(auth);
  }
  gridRequest!: AnyoPackSubscriptionGridRequest;
  pageSizeOptions = [10, 20, 50, 100];
  tableLoading: boolean = false;
  globalSearchInput: string = '';
  page: number = 1;
  pageSize: number = 10;
  totalRecords: number = 0;
  showTest: boolean = false;
  partnerIdFilter: string[] = [];
  partnerIdCheckBoxOptions: CheckboxOptions[] = [];
  tableData: AnyoPacksSubscriptionResponse[] = [];
  async ready() {
    if (this.user) {
      await this.fetchPacksSubscription();
    }
  }

  async fetchPacksSubscription() {
    this.tableLoading = true;
    this.gridRequest = {
      from: undefined,
      to: undefined,
      page: this.page,
      pageSize: this.pageSize,
      filters: {
        TEST_PACK: [this.showTest ? 'true' : 'false'],
        ALL_SESSION_COMPLETED: [],
        PAYMENT_TYPE: [],
        USER_ID: [],
        PACKAGE_ID: [],
        PARTNER_ID: [],
        UNIQUE_USER: ['true'],
      },
      export: false,
    };
    if (this.globalSearchInput) {
      this.gridRequest.globalSearch = [this.globalSearchInput];
    }
    if (this.partnerIdFilter && this.partnerIdFilter.length) {
      this.gridRequest.filters!.PARTNER_ID = this.partnerIdFilter;
    }
    if (this.dateRange && this.dateRange.length == 2) {
      console.log(this.dateRange);
      this.gridRequest!.from = Number(moment(this.dateRange[0]).format('x'));
      this.gridRequest!.to = Number(moment(this.dateRange[1]).format('x'));
    }
    this.packService.getPacksSubscriptionGrid(this.gridRequest).subscribe({
      next: (res) => {
        this.tableData = res.data;
        this.page = res.pageNum;
        this.pageSize = res.pageSize;
        this.totalRecords = res.totalRecords;
        this.partnerIdCheckBoxOptions = res.filterOptions.partners.map(
          (data) => {
            if (this.partnerIdFilter.includes(data.partnerId)) {
              return {
                value: data.partnerId,
                label: data.partnerId + '-' + data.companyName,
                checked: true,
              };
            } else {
              return {
                value: data.partnerId,
                label: data.partnerId + '-' + data.companyName,
                checked: false,
              };
            }
          },
        );
        this.tableLoading = false;
      },
      error: (err) => {
        console.log(err);
        this.tableLoading = false;
      },
    });
  }
  resetFilter() {
    this.page = 1;
    this.pageSize = 10;
    this.globalSearchInput = '';
    this.partnerIdFilter = [];
    this.dateRange = [];
    this.fetchPacksSubscription();
  }
  testEventChangeFn($event: boolean) {
    this.showTest = $event;
    this.fetchPacksSubscription();
  }
  nzPageIndexChange($event: number) {
    this.page = $event;
    this.fetchPacksSubscription();
  }
  nzPageSizeChange($event: number) {
    this.pageSize = $event;
    this.fetchPacksSubscription();
  }
  goToFilterUsers(userId: string) {
    window.open(`packs/subscription?userId=${userId}`);
  }
  partnerIdFilterChangeFn($event: string[]) {
    if ($event && $event.length) {
      this.partnerIdFilter = $event;
    }
  }

  async exportDataFn() {
    this.pageLoading = true;
    this.gridRequest.export = true;
    const gridResp = await lastValueFrom(
      this.packService.getPacksSubscriptionGrid(this.gridRequest!),
    );
    const exportData = gridResp.data.map((value) => {
      const payload: AnyoPacksSubscriptionExportData = {
        packName: value.packName,
        activedOn: value.activedOn,
        validTill: value.validTill,
        totalPacks: value.totalPacks,
        activePacks: value.activePacks,
        completedPacks: value.completedPacks,
        totalPackValue: value.totalPackValue,
        paymentType: value.paymentType,
        primaryConcern: value.primaryConcern,
        primaryTherapistDetails: value.primaryTherapistDetails.name,
        auxiliaryTherapistDetails: value.auxiliaryTherapistDetails
          .map((data) => data.name)
          .join(','),
        numberOfPrimarySessions: value.numberOfPrimarySessions,
        numberOfAuxiliarySessions: value.numberOfAuxiliarySessions,
        userDetails: value.userDetails,
        completedPrimarySession: value.completedPrimarySession,
        completedAuxiliarySession: value.completedAuxiliarySession,
        auxiliaryConcern: value.auxiliaryConcern.join(','),
      };
      return payload;
    });
    try {
      this.fileUtil.exportCSV<AnyoPacksSubscriptionExportData>(
        exportData,
        `packs_export_${moment().format('dd/mm/yyy hh:mm a')}`,
      );
      this.pageLoading = false;
    } catch (e) {
      this.toastService.showError('Export Error');
      this.pageLoading = false;
    }
  }

  dateFormat = 'dd/MM/yyyy';
  dateRange: Date[] | undefined;

  disabledDate = (current: Date) => {
    return moment(current).isBefore(moment('01/10/2023', 'dd/MM/YYYY'));
  };

  async dateChange(_: Date[]) {
    await this.fetchPacksSubscription();
  }
}
